import { compareService } from '@/fo/api/magento';
import { toastCompareAdded } from '@/fo/ui/toast/added';

import { storeProduct } from '../lib/store';

/** Данные товара для тоста «Добавлен в сравнение» */
export type AddToCompareToastPayload = {
  name?: string;
  imageUrl?: string;
};

const addProductToCompare = async (
  id?: string | number | null,
  toastPayload?: AddToCompareToastPayload
) => {
  const response = await compareService.addProductsToCompare(id);

  if (response?.items) {
    response?.items.forEach((item) => {
      if (item?.product && item?.product.sku) {
        storeProduct.send({
          type: 'setProductCompare',
          sku: item?.product.sku,
          compare: {
            id: item?.product?.id?.toString() ?? '',
            count: 1
          }
        });
      }
    });

    const firstItem = response.items[0];
    const subtitle = toastPayload?.name ?? firstItem?.product?.name ?? '';
    if (
      subtitle &&
      response.toastTitle != null &&
      response.toastButtonText != null
    ) {
      toastCompareAdded({
        src: toastPayload?.imageUrl ?? '',
        subtitle,
        title: response.toastTitle,
        buttonText: response.toastButtonText,
        style: { top: '45px' }
      });
    }
  }
};

const removeProductFromCompare = async (id?: string | number | null) => {
  const response = await compareService.removeCompareItems(id);

  if (response?.items) {
    response?.items.forEach((item) => {
      if (item?.product && item?.product.sku) {
        storeProduct.send({
          type: 'setProductCompare',
          sku: item?.product.sku,
          compare: undefined
        });
      }
    });
  }
};

const clearCompareList = async () => {
  const { errorMessage } = await compareService.removeAllCompareItems();
  if (!errorMessage) {
    storeProduct.send({ type: 'setClearedCompare' });
  }
  return { errorMessage };
};

export const compareActions = {
  addProductToCompare,
  removeProductFromCompare,
  clearCompareList
};
